<div>
    <div class="mb-8 text-center font-semibold text-xl">Share</div>

    <div [style.width.px]="538 * scale" [style.height.px]="414.8 * scale">
        <div [style.transform]="'scale(' + scale + ')'" [style.transform-origin]="'top left'">
            <div #contentToDownload style="width: 538px; height: 414.8px; padding: 24px; color: #ffffff; position: relative; background-color: #000">
                <img src="/assets/imgs/hemera-god.png" style="height: 100%; position: absolute; top: 0; left: 0; right: 0; bottom: 0; z-index: 0" alt="" />
                <div style="position: relative; z-index: 1">
                    <img src="/assets/imgs/logo/socialscan-logo-gradient.png" alt="" style="height: 27px" />
                    <div style="margin-top: 16px; font-size: 24px; font-weight: 600; line-height: 36px">
                        Trade Your Next 1000x MEME
                        <br />
                        with SocialScan Hunter Agent.
                    </div>

                    <div style="margin-top: 26px; margin-bottom: 30px; width: 87px; height: 1px; background-color: #ffffff"></div>

                    <div>
                        <div style="font-size: 15px; line-height: 16px">7D PnL :</div>

                        <div style="display: flex; align-items: center; gap: 12px; margin-top: 4px">
                            <div style="font-size: 48px; font-weight: 600" [ngStyle]="{'color': agentInfo?.stats.pnl_7d > 0 ? '#12be51' : '#ff0000'}">
                                {{formatTinyNumber(agentInfo?.stats.pnl_7d || 0)}}
                            </div>
                            <div
                                style="padding: 0 8px; border-radius: 4px; font-size: 16px"
                                [ngClass]="{
                                    'text-[#ff0000] bg-[#ff000019]': agentInfo?.stats.pnl_7d <= 0,
                                    'text-[#12be51] bg-[#12be5119]': agentInfo?.stats.pnl_7d > 0,
                                }"
                            >
                                {{agentInfo?.stats.pnl_7d > 0 ? '+' : ''}}{{(agentInfo?.stats.pnl_7d / agentInfo?.stats.buy_usd_7d || 0)|percent:'1.0-2'}}
                            </div>
                        </div>

                        <div style="margin-top: 4px; display: flex; align-items: center; justify-content: flex-start; font-size: 15px">
                            <div style="color: #999999">Win Rate : &nbsp;</div>
                            <div style="color: #f7f7f7">{{(agentInfo?.stats.win_rate || 0) | percent:'1.0-2'}}</div>
                        </div>

                        <div style="display: flex; justify-content: space-between; align-items: flex-end; margin-top: 24px">
                            <div style="display: flex; align-items: center; gap: 12px">
                                <div class="w-12 h-12 rounded-full border border-sub-text bg-[#f7f7f7]">
                                    <img *ngIf="agentInfo.logo_url" class="avatar rounded-full w-full h-full object-cover" [src]="agentInfo.logo_url" alt="" />
                                </div>
                                <div>
                                    <div style="font-size: 16px; line-height: 22px; font-weight: 500">{{agentInfo.name || 'Unnamed'}}</div>
                                    <div *ngIf="agentInfo?.wallet_address" style="font-size: 9px; color: #999999; line-height: 14px">
                                        By {{commonService.getAddrName(agentInfo) | address}}
                                    </div>
                                </div>
                            </div>

                            <div style="font-size: 12px; display: flex; justify-content: flex-start; align-items: center; gap: 8px">
                                <div
                                    *ngIf="shareLink"
                                    style="
                                        width: 52px;
                                        height: 52px;
                                        border-radius: 4px;
                                        background-color: #fff;
                                        display: flex;
                                        justify-content: center;
                                        align-items: center;
                                        overflow: hidden;
                                    "
                                >
                                    <qrcode
                                        [qrdata]="shareLink"
                                        [allowEmptyString]="true"
                                        [colorDark]="'#000000ff'"
                                        [colorLight]="'#ffffffff'"
                                        [elementType]="'canvas'"
                                        [errorCorrectionLevel]="'M'"
                                        [margin]="1"
                                        [scale]="1"
                                        [width]="96"
                                        style="transform: scale(0.5)"
                                    ></qrcode>
                                </div>

                                <div *ngIf="referralCode">
                                    <div style="color: #999999">Referral code</div>
                                    <div style="font-weight: 500">{{referralCode}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="mt-8 flex justify-around items-start">
        <div class="flex flex-col items-center justify-center">
            <button nz-button nzShape="round" (click)="startShareToTwitter()" class="w-10 h-10 !p-2.5 rounded-full !bg-black !text-white">
                <span nz-icon nzType="antd:x" class="text-xl"></span>
            </button>
            <div class="mt-2 text-xs">Twitter</div>
        </div>

        <div class="flex flex-col items-center justify-center">
            <button nz-button nzShape="round" (click)="copyToClipboard()" class="w-10 h-10 !p-2.5 rounded-full !border-[#E6E6E6] border">
                <span nz-icon [nzType]="generatingImage ? 'loading' : 'copy'" class="text-2xl"></span>
            </button>

            <div class="mt-2 text-xs">Copy</div>
        </div>
    </div>
</div>
